import React, { useContext, useEffect, useState } from 'react'
import {
  Box,
  Button,
  Container,
  FormControl,
  FormControlLabel,
  Grid,
  Input,
  InputLabel, MenuItem,
  Paper, Select,
  Switch,
  TextField,
}                                                 from '@mui/material'
import { useTranslation }                         from 'react-i18next'
import { useNavigate, useParams }                 from 'react-router-dom'
import { useApi }                                 from '../utils/api'
import { useSnackbar }                            from 'notistack'
import AlertSimpleDialog                          from '../ui/components/alert-simple-dialog'
import Page                                       from '../ui/components/Page'
import { BaseBreadcrumbs }                        from '../ui/components/BaseBreadcrumbs'
import { AppContext }                             from '../App'

export default function PartnerPage() {

  const api = useApi()
  const { user } = useContext(AppContext)
  const navigate = useNavigate()
  const { partnerId } = useParams()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()
  const [values, setValues] = useState({
    name: '',
    billingInfo: '',
  })
  const [shownDeleteDialog, setShownDeleteDialog] = useState(false)

  useEffect(() => {
    (async () => {
      if (!isNaN(partnerId)) {
        try{
          let partner = await api.partner.detail(partnerId)
          setValues({
            name: '',
            ...partner
          })
        } catch (e){
          enqueueSnackbar(t('Can\'t load partner'), {
            variant: "error"
          })
        }
      }
    })()
  }, [partnerId])

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value })
  }

  const handleCloseDeleteDialog = (result) => {
    setShownDeleteDialog(false)
    if (result) {
      api.partner.delete(partnerId).then(() => {
        enqueueSnackbar(t('Partner deleted'), {
          variant: 'success'
        })
        navigate('/dashboard/partners')
      }).catch(error => {
        enqueueSnackbar(t('Failed to delete partner'), {
          variant: 'error'
        })
      })
    }
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    let data = { ...values }
    try {
      let partner = await api.partner.save(data)
      navigate(`/partners/${partner.id}`)
      enqueueSnackbar(t('Partner saved'), {
        variant: 'success'
      })
    } catch (e) {
      enqueueSnackbar(t('Failed to save partner'), {
        variant: 'error'
      })
    }
  }

  return (
    <Page title={t('Partner')}>
      <Container component="main">
        <BaseBreadcrumbs key={'breadcrumb-partner'}
                         title={values?.name ?? t('Partner')}
                         items={[
                           { title: t('Partners'), href: `/partners` }
                         ]}/>
        <Grid component={'form'} onSubmit={onSubmit} item xs={12}>
          <Paper sx={{ p: 2, width: '100%' }}>
            <Grid container sx={{ width: '100%' }} spacing={2}>
              <Grid item xs={12}>
                <FormControl fullWidth variant="standard">
                  <InputLabel htmlFor="user-name">{t('Name')}</InputLabel>
                  <Input
                    id="user-name"
                    value={values.name}
                    onChange={handleChange('name')}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <FormControl variant="standard" fullWidth>
                <TextField
                    id="info-billingInfo"
                    label={t('Billing info')}
                    multiline
                    rows={6}
                    variant="standard"
                    value={values.billingInfo}
                    onChange={handleChange('billingInfo')}
                    sx={{ width: '100%' }}/>
              </FormControl>
            </Grid>
          </Paper>
          <Box sx={{ mt: 2, px: 1 }}>
            <Button type={'submit'} variant={'contained'} disabled={user?.readonly}>{t('Save')}</Button>
            { !isNaN(partnerId) && (<Button type={'button'} color={'error'} variant={'contained'} sx={{ ml: 2 }} disabled={user?.readonly} onClick={() => { setShownDeleteDialog(true) }}>{t('Delete')}</Button>) }
          </Box>
        </Grid>
        <AlertSimpleDialog
          title={t('Deleting partner')}
          message={t('delete-confirm-msg', { name: values.name })}
          open={shownDeleteDialog}
          onClose={handleCloseDeleteDialog}
        />
      </Container>
    </Page>
  )
}